'use client'

import Link from 'next/link'

const DATA_SOURCES = [
  { label: 'Transfermarkt', href: 'https://www.transfermarkt.us' },
  { label: 'Livescore',     href: 'https://www.livescore.com/' },
  { label: 'Flashscore',   href: 'https://www.flashscore.ca/soccer' },
]

export function SiteFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="w-full border-t-2 border-white/20 shadow-[0_-4px_10px_-2px_rgba(0,0,0,0.6)] px-5 py-6" style={{ background: '#1c1c1c' }}>
      <div className="mx-auto max-w-5xl flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">

        {/* Left: copyright + contact */}
        <div className="flex items-center gap-4 flex-wrap">
          <span className="text-xs text-white/25">© {year} Goal Archive</span>
          <span className="hidden sm:block h-3 w-px bg-white/10" />
          <Link
            href="/contact"
            className="text-xs text-white/40 hover:text-white/70 transition-colors no-underline"
          >
            Contact
          </Link>
        </div>

        {/* Right: data sources */}
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-xs text-white/20">Data:</span>
          {DATA_SOURCES.map((src, i) => (
            <span key={src.href} className="flex items-center gap-1.5">
              {i > 0 && <span className="text-white/15">·</span>}
              <a
                href={src.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-white/35 hover:text-white/65 transition-colors no-underline"
              >
                {src.label}
              </a>
            </span>
          ))}
        </div>

      </div>
    </footer>
  )
}
